var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#EDF1FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12l3.09 6.26L32 19.27l-5 4.87 1.18 6.88L22 27.77l-6.18 3.25L17 24.14l-5-4.87 6.91-1.01L22 12z",
    stroke: "#476FF2",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQ0IiBoZWlnaHQ9IjQ0IiByeD0iMjIiIGZpbGw9IiNFREYxRkMiLz4KPHBhdGggZD0iTTIyIDEyTDI1LjA5IDE4LjI2TDMyIDE5LjI3TDI3IDI0LjE0TDI4LjE4IDMxLjAyTDIyIDI3Ljc3TDE1LjgyIDMxLjAyTDE3IDI0LjE0TDEyIDE5LjI3TDE4LjkxIDE4LjI2TDIyIDEyWiIgc3Ryb2tlPSIjNDc2RkYyIiBzdHJva2Utd2lkdGg9IjEuNiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgCircleStar as ReactComponent };